import React, { useState } from "react";
import Scrollbar from "react-scrollbars-custom";
import TeamTodoListTask from "views/Teams/TeamTodoList/TeamTodoListTask/TeamTodoListTask";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import "assets/scss/partials/microsoftTeams.scss";

export default ({ children, listTodoId , listTeamId }) => {
  const [dialog, setDialog] = useState(false);

  return (
    <>
      <div onClick={() => setDialog(true)}>{children}</div>
      <Modal
        open={dialog}
        closeOnOverlayClick={false}
        onClose={() => setDialog(false)}
        showCloseIcon={false}
        center={true}
        classNames={{ modal: "microsoftTeamUserPollListDetail" }}
        closeOnEsc={false}
      >
        <div className="microsoftTeamsDialogHeader todoListMicrosoftTeamButton">
          {" "}
          Todo List Item
          <div className="closeMicrosoftTeamsDialog">
            <CloseIcon onClick={() => setDialog(false)} className="cursor" />
          </div>
        </div>
        <div className="todoListMicrosoftPadding">
          <Scrollbar style={{ height: "calc(100vh - 100px)" }}>
            <div>
              <TeamTodoListTask listTodoId={listTodoId} listTeamId={listTeamId}/>
            </div>
          </Scrollbar>
        </div>
      </Modal>
    </>
  );
};
